import { InjectionToken, WritableSignal, signal } from '@angular/core';

export const IS_NEW_USER_OR_BOT = new InjectionToken<WritableSignal<boolean>>('Check is new user or search bot', {
  factory: () => {
    return signal(null);
  },
});
